import { createSelector } from 'reselect'

import { RootState } from 'redux/store'
import { PlaceholdersState } from 'redux/reducers/placeholders'

const selectPlaceholders = createSelector(
  (state: RootState) => state.placeholders,
  (placeholders: PlaceholdersState) => placeholders
)

export default selectPlaceholders
